"use client";

// src/header/index.tsx
import { useEffect as useEffect4, useState as useState4 } from "react";
import { LogotypeRuterPrimary, LogotypeRuterSecondary } from "@ds/logos";
import { getSanityLocalizedField as getSanityLocalizedField2 } from "@web-common/utils";

// src/header/menu.tsx
import { cn as cn3 } from "@web-common/utils";

// ../../node_modules/@ds/icons/index.esm.js
import { jsxs, jsx } from "react/jsx-runtime";
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function ChevronDown(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--ChevronDown ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      d: "m12 14.379-6.31-6.23a.518.518 0 0 0-.726 0l-.814.803c-.2.198-.2.519 0 .717l7.124 7.034a1.036 1.036 0 0 0 1.452 0L19.85 9.67c.2-.198.2-.519 0-.717l-.814-.804a.518.518 0 0 0-.726 0L12 14.378Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--ChevronDown {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--ChevronDown:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}
function ChevronLeft(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--ChevronLeft ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      d: "m9.586 12 6.146 6.146a.5.5 0 0 1 0 .707l-.793.793a.5.5 0 0 1-.707 0l-6.94-6.939a1 1 0 0 1 0-1.414l6.94-6.94a.5.5 0 0 1 .707 0l.793.793a.5.5 0 0 1 0 .707L9.586 12Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--ChevronLeft {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--ChevronLeft:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}
function ChevronRight(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--ChevronRight ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      d: "M15.293 12 9.146 5.854a.5.5 0 0 1 0-.708l.793-.792a.5.5 0 0 1 .707 0l6.94 6.939a1 1 0 0 1 0 1.414l-6.94 6.94a.5.5 0 0 1-.707 0l-.793-.793a.5.5 0 0 1 0-.707L15.293 12Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--ChevronRight {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--ChevronRight:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}
function Cross(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--Cross ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      d: "m12 13.414 5.44 5.44a.5.5 0 0 0 .706 0l.708-.708a.5.5 0 0 0 0-.707L13.414 12l5.44-5.44a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L12 10.586l-5.44-5.44a.5.5 0 0 0-.706 0l-.708.708a.5.5 0 0 0 0 .707L10.586 12l-5.44 5.44a.5.5 0 0 0 0 .706l.708.708a.5.5 0 0 0 .707 0L12 13.414Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--Cross {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--Cross:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}
function Gear(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--Gear ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.19 2.757A1 1 0 0 0 13.22 2h-2.44a1 1 0 0 0-.97.757L9.524 3.91a1.078 1.078 0 0 1-.638.72 7.996 7.996 0 0 0-1.709.988c-.27.205-.617.286-.942.193L5.09 5.483a1 1 0 0 0-1.14.461L2.73 8.056a1 1 0 0 0 .17 1.219l.856.826c.242.235.346.576.304.911a8.076 8.076 0 0 0 0 1.976c.042.335-.062.677-.305.911l-.854.826a1 1 0 0 0-.17 1.22l1.218 2.11a1 1 0 0 0 1.141.462l1.144-.327c.325-.093.673-.012.942.193a7.992 7.992 0 0 0 1.709.988c.311.132.556.392.638.72l.288 1.151a1 1 0 0 0 .97.758h2.438a1 1 0 0 0 .97-.758l.288-1.151c.082-.328.326-.588.638-.72a7.997 7.997 0 0 0 1.709-.988c.27-.204.617-.286.942-.193l1.144.327a1 1 0 0 0 1.14-.461l1.22-2.112a1 1 0 0 0-.171-1.219l-.855-.826a1.078 1.078 0 0 1-.305-.911 8.072 8.072 0 0 0 0-1.976 1.078 1.078 0 0 1 .305-.91l.855-.827a1 1 0 0 0 .17-1.22l-1.218-2.11a1 1 0 0 0-1.141-.462l-1.144.327a1.077 1.077 0 0 1-.942-.193 7.998 7.998 0 0 0-1.71-.988 1.078 1.078 0 0 1-.637-.72l-.288-1.152ZM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--Gear {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--Gear:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}
function Hamburger(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--Hamburger ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 7.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v1Zm0 5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v1Zm-.5 5.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--Hamburger {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--Hamburger:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}
function InfoCircle(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--InfoCircle ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-11-.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6ZM12 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--InfoCircle {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--InfoCircle:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}
function Language(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--Language ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2Zm6.93 6h-2.95a15.65 15.65 0 0 0-1.38-3.56A8.03 8.03 0 0 1 18.92 8ZM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96ZM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26Zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 0 1 5.08 16Zm2.95-8H5.08a7.987 7.987 0 0 1 4.33-3.56A15.65 15.65 0 0 0 8.03 8ZM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96ZM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2Zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56ZM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--Language {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--Language:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}
function Moon(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--Moon ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      d: "M16.805 17c-4.54 0-8.225-3.733-8.225-8.333a8.29 8.29 0 0 1 2.225-5.665c.328-.352.094-.96-.38-.885C5.715 2.857 2 7.03 2 12c0 5.517 4.425 10 9.87 10 3.594 0 6.727-1.945 8.455-4.845.247-.414-.232-.859-.681-.686a7.85 7.85 0 0 1-2.839.531Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--Moon {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--Moon:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}
function ProfileOutlineThicker(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--ProfileOutlineThicker ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      d: "M12 7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10 0 .146-.006.291-.012.435-.002.044-.002.087-.005.13-.007.137-.018.274-.03.41l-.012.094a9.953 9.953 0 0 1-.134.891l-.015.076a10.001 10.001 0 0 1-.23.902l-.035.102a9.813 9.813 0 0 1-.113.336l-.03.084c-.048.13-.099.257-.152.384l-.034.083a9.95 9.95 0 0 1-.391.811l-.022.04c-.064.117-.129.233-.197.347l-.07.113a9.981 9.981 0 0 1-.487.719l-.025.035a10.338 10.338 0 0 1-.583.707l-.052.056a9.863 9.863 0 0 1-.622.622l-.041.038a9.966 9.966 0 0 1-.31.27l-.087.07a9.943 9.943 0 0 1-.311.246c-.083.062-.169.12-.254.18-.052.037-.103.075-.155.111a10 10 0 0 1-.358.23l-.14.083c-.086.05-.172.1-.259.148l-.1.056a9.86 9.86 0 0 1-.802.386l-.104.043a9.818 9.818 0 0 1-.31.123l-.135.051c-.27.097-.544.182-.823.256l-.152.038c-.105.026-.21.05-.316.072l-.123.027a9.964 9.964 0 0 1-.895.136c-.047.006-.095.01-.142.014a9.976 9.976 0 0 1-.49.033 9.279 9.279 0 0 1-.906 0c-.056-.002-.113-.007-.169-.01a9.862 9.862 0 0 1-.787-.08l-.155-.023a9.979 9.979 0 0 1-.353-.063l-.108-.02a10.06 10.06 0 0 1-.43-.1l-.14-.038a9.786 9.786 0 0 1-.311-.088l-.166-.052a9.825 9.825 0 0 1-.24-.082l-.198-.07c-.089-.034-.177-.07-.265-.106l-.138-.057a9.935 9.935 0 0 1-.805-.387l-.132-.074a10.291 10.291 0 0 1-.661-.402l-.098-.064a9.956 9.956 0 0 1-.303-.215c-.025-.02-.052-.037-.077-.056-.106-.08-.21-.162-.312-.245l-.085-.07a9.923 9.923 0 0 1-.312-.271l-.041-.038a10.073 10.073 0 0 1-.622-.622l-.052-.056a10.054 10.054 0 0 1-.583-.707l-.025-.035a10.003 10.003 0 0 1-.487-.719l-.069-.113a9.886 9.886 0 0 1-.198-.347l-.022-.04a9.961 9.961 0 0 1-.39-.811l-.035-.083a9.99 9.99 0 0 1-.152-.384l-.03-.084a9.924 9.924 0 0 1-.113-.336l-.034-.102a9.944 9.944 0 0 1-.14-.505 9.881 9.881 0 0 1-.091-.397l-.014-.076a9.98 9.98 0 0 1-.177-1.396c-.003-.042-.003-.085-.005-.129A10.436 10.436 0 0 1 2 12C2 6.477 6.477 2 12 2Zm0 1.818a8.182 8.182 0 0 0-5.885 13.864A3 3 0 0 1 9 15.5h6c1.373 0 2.527.923 2.884 2.182A8.181 8.181 0 0 0 12 3.819Z",
      fill: "var(--fill-2, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--ProfileOutlineThicker {--fill-0: currentcolor; --fill-1: currentcolor; --fill-2: currentcolor;}
        .rds-icon--ProfileOutlineThicker:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor; --fill-2: currentcolor;}
      `
      }
    })]
  }));
}
function Search(props) {
  const {
    className
  } = props, otherProps = __rest(props, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "var(--fill-0, currentcolor)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: `rds-icon rds-icon--Search ${className !== null && className !== void 0 ? className : ""}`,
    "aria-hidden": true,
    focusable: false
  }, otherProps, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.172 17.94c-.35-.351-.902-.386-1.328-.132a8.5 8.5 0 1 1 2.964-2.964c-.254.426-.219.977.132 1.328l4.09 4.09a.5.5 0 0 1 0 .708l-1.06 1.06a.5.5 0 0 1-.707 0l-4.091-4.09Zm.328-7.44a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z",
      fill: "var(--fill-1, currentcolor)"
    }), jsx("style", {
      dangerouslySetInnerHTML: {
        __html: `
        .rds-icon--Search {--fill-0: currentcolor; --fill-1: currentcolor;}
        .rds-icon--Search:where([data-color-scheme="dark"], [data-color-scheme="dark"] *) {--fill-0: currentcolor; --fill-1: currentcolor;}
      `
      }
    })]
  }));
}

// src/header/navigation-menu.tsx
import {
  getSanityLocalizedField,
  useCookieBannerStore
} from "@web-common/utils";
import { useEffect, useState } from "react";
import { cn } from "@web-common/utils";

// src/common/IllustrationBlock.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var IllustrationBlock = ({
  svg,
  className = "size-6"
}) => {
  return svg ? /* @__PURE__ */ jsx2("div", { dangerouslySetInnerHTML: { __html: svg }, className }) : null;
};

// src/header/navigation-menu.tsx
import { Input } from "@ds/input";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var NavigationMenu = ({
  language,
  primaryMenu,
  onClickTracking,
  languageUrl,
  show,
  query,
  domain,
  searchUrl,
  isLoggedIn,
  setActiveMenu
}) => {
  const [linkIndex, setLinkIndex] = useState(-1);
  const { setOpen } = useCookieBannerStore();
  const changeLanguage = () => {
    if (languageUrl) {
      return `${languageUrl}`;
    }
    if (language === "no") {
      return "/en";
    }
    return "/no";
  };
  const currentUrl = typeof window !== "undefined" ? window.location.pathname : null;
  useEffect(() => {
    if (currentUrl) {
      setActiveMenu("closed");
    }
  }, [currentUrl]);
  return /* @__PURE__ */ jsx3(
    "nav",
    {
      className: cn(
        "fixed right-0 top-0 z-[21] translate-x-[100%] h-full w-full ease-in bg-background-secondary motion-reduce:duration-0 md:w-[572px] md:pt-[80px] pt-[72px] ",
        show && "translate-x-0 ",
        show ? "duration-450" : "duration-0"
      ),
      children: /* @__PURE__ */ jsxs2("div", { className: "h-full overflow-y-auto overflow-x-hidden  md:px-10 ", children: [
        /* @__PURE__ */ jsx3(
          "form",
          {
            action: searchUrl || "/no/en",
            className: "pb-4 md:pb-8 w-full px-5 pt-1 ",
            children: /* @__PURE__ */ jsx3(
              Input,
              {
                name: query || "q",
                rounded: true,
                className: "",
                autoComplete: "off",
                leading: {
                  className: "ml-3 mr-2",
                  item: /* @__PURE__ */ jsx3(Search, { className: "w-6 h-6" })
                },
                slotProps: {
                  root: {
                    className: "w-full"
                  },
                  container: {
                    className: "!border focus-within:!outline-1 focus-within:!outline-tint-accent-primary focus-within:!border-tint-accent-primary"
                  }
                },
                onFocus: () => {
                  setActiveMenu("navigation");
                },
                type: "search",
                placeholder: language === "no" ? "S\xF8k p\xE5 ruter.no" : "Search ruter.no"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs2("ul", { className: "list-none p-0 text-ink-primary", children: [
          primaryMenu?.map((link, i) => /* @__PURE__ */ jsxs2(
            "li",
            {
              className: "border-b typography-body-medium border-fill-tertiary hover:bg-fill-quaternary",
              children: [
                link._type === "navigationLink" ? /* @__PURE__ */ jsxs2(
                  "button",
                  {
                    className: "flex w-full items-center justify-between px-5 py-4 ",
                    onClick: () => setLinkIndex(linkIndex === i ? -1 : i),
                    children: [
                      /* @__PURE__ */ jsxs2("span", { className: "flex items-center gap-2", children: [
                        link.icon && /* @__PURE__ */ jsx3(IllustrationBlock, { className: "size-5", svg: link.icon }),
                        getSanityLocalizedField(link.title, language)
                      ] }),
                      /* @__PURE__ */ jsx3(ChevronDown, { className: "size-4 h-[27px] text-ink-tertiary" })
                    ]
                  }
                ) : /* @__PURE__ */ jsxs2(
                  "a",
                  {
                    className: "flex items-center gap-2 md:px-5 px-5 py-4 no-underline hover:text-ink-primary ",
                    href: new URL(link.url, domain).href,
                    onClick: () => {
                      if (onClickTracking) {
                        onClickTracking(link.url);
                      }
                    },
                    children: [
                      link.icon && /* @__PURE__ */ jsx3(IllustrationBlock, { className: "size-5", svg: link.icon }),
                      getSanityLocalizedField(link.title, language)
                    ]
                  }
                ),
                linkIndex == i && /* @__PURE__ */ jsx3("ul", { className: "mx-5 list-none p-0 pb-6 text-ink-primary", children: primaryMenu[linkIndex]?._type === "navigationLink" && primaryMenu[linkIndex]?.links.map((link2, i2) => /* @__PURE__ */ jsx3(
                  "li",
                  {
                    className: "border-l-2 typography-body-medium border-fill-tertiary hover:bg-fill-quaternary",
                    children: /* @__PURE__ */ jsx3("a", { className: "block px-7 py-3", href: link2.url, children: getSanityLocalizedField(link2.label, language) })
                  },
                  `primaryMenuLinks_${linkIndex}_${i2}`
                )) })
              ]
            },
            `primaryMenu_${i}`
          )),
          /* @__PURE__ */ jsx3("li", { className: "border-b typography-body-medium border-fill-tertiary hover:bg-fill-quaternary", children: /* @__PURE__ */ jsxs2(
            "a",
            {
              className: "flex items-center gap-2 md:px-5 px-5 py-4 no-underline hover:text-ink-primary",
              href: "https://minside.ruter.no",
              children: [
                /* @__PURE__ */ jsx3(ProfileOutlineThicker, { className: "size-5" }),
                isLoggedIn ? language === "no" ? "Profil" : "Profile" : language === "no" ? "Logg inn" : "Log in"
              ]
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx3("div", { className: "mt-10 border-b md:px-5 px-5 pb-4 typography-title-small text-ink-primary border-fill-tertiary", children: language === "no" ? "Innstillinger" : "Settings" }),
        /* @__PURE__ */ jsxs2("ul", { className: "list-none p-0 text-ink-primary", children: [
          /* @__PURE__ */ jsx3("li", { className: "border-b typography-body-medium border-fill-tertiary hover:bg-fill-quaternary", children: /* @__PURE__ */ jsxs2(
            "a",
            {
              className: "flex w-full items-center gap-4 md:px-5 py-4 px-5 no-underline hover:text-ink-primary",
              href: changeLanguage(),
              children: [
                /* @__PURE__ */ jsx3(Language, { className: "size-5" }),
                language === "en" ? "Norsk" : "English",
                /* @__PURE__ */ jsx3(ChevronRight, { className: "ml-auto size-4 text-ink-tertiary" })
              ]
            }
          ) }),
          /* @__PURE__ */ jsx3("li", { className: "border-b typography-body-medium border-fill-tertiary hover:bg-fill-quaternary", children: /* @__PURE__ */ jsxs2(
            "button",
            {
              className: "flex w-full items-center gap-4 md:px-5 px-5 py-4",
              onClick: () => {
                setOpen(true);
              },
              children: [
                /* @__PURE__ */ jsx3(Gear, { className: "size-5" }),
                language === "no" ? "Informasjonskapsler" : "Cookies",
                /* @__PURE__ */ jsxs2("span", { className: "ml-auto flex items-center gap-2 typography-body-medium text-ink-secondary", children: [
                  language === "no" ? "Endre" : "Change",
                  /* @__PURE__ */ jsx3(ChevronRight, { className: "ml-auto size-4 text-ink-tertiary" })
                ] })
              ]
            }
          ) }),
          /* @__PURE__ */ jsx3("li", { className: "border-b typography-body-medium border-fill-tertiary hover:bg-fill-quaternary mb-10", children: /* @__PURE__ */ jsxs2(
            "button",
            {
              className: "flex w-full items-center gap-4 md:px-5 px-5 py-4",
              onClick: () => setActiveMenu("theme"),
              onKeyDown: (e) => {
                if (e.key === "Tab") {
                  setActiveMenu("closed");
                }
              },
              children: [
                /* @__PURE__ */ jsx3(Moon, { className: "size-5" }),
                " ",
                language === "no" ? "M\xF8rk modus" : "Dark mode",
                /* @__PURE__ */ jsxs2("span", { className: "ml-auto flex items-center gap-2 typography-body-medium text-ink-secondary", children: [
                  language === "no" ? "Endre" : "Change",
                  /* @__PURE__ */ jsx3(ChevronRight, { className: "ml-auto size-4 text-ink-tertiary" })
                ] })
              ]
            }
          ) })
        ] })
      ] })
    }
  );
};

// src/header/change-theme.tsx
import { RadioGroup } from "@ds/radio-group";
import { Radio } from "@ds/radio";
import { cn as cn2 } from "@web-common/utils";
import Cookies2 from "universal-cookie";
import { useEffect as useEffect2, useState as useState2 } from "react";

// src/header/utils.ts
import Cookies from "universal-cookie";
function getDomain() {
  const host = window.location.hostname;
  const domain = host.substring(host.indexOf("."));
  if (host.startsWith("localhost")) {
    return "localhost";
  }
  return domain;
}
function checkLoggedIn(env) {
  const cookies2 = new Cookies();
  const loggedIn = cookies2.get(env !== "prod" ? `loggedIn-${env}` : "loggedIn");
  return !!loggedIn;
}

// src/header/change-theme.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var cookies = new Cookies2();
var ChangeTheme = ({
  language,
  show,
  closeTheme,
  onToggleClickTracking
}) => {
  const [currentTheme, setCurrentTheme] = useState2();
  useEffect2(() => {
    const theme = cookies.get("theme") || "auto";
    setCurrentTheme(theme);
  }, []);
  const toggleTheme = (theme) => {
    const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    document.documentElement.setAttribute(
      "data-color-scheme",
      theme === "auto" ? systemTheme : theme
    );
    onToggleClickTracking?.(theme);
    const domain = getDomain();
    cookies.set("theme", theme, { domain, path: "/", maxAge: 31536e3 });
    setCurrentTheme(theme);
  };
  return /* @__PURE__ */ jsxs3(
    "nav",
    {
      className: cn2(
        "fixed right-0 top-0 z-[60] h-full translate-x-[100%] w-full duration-200 bg-background-secondary motion-reduce:duration-0 md:w-[572px]",
        show && "translate-x-0"
      ),
      children: [
        /* @__PURE__ */ jsxs3(
          "button",
          {
            onClick: closeTheme,
            className: "flex h-[72px] items-center gap-2 px-5 md:px-10 text-ink-primary md:h-[100px]",
            children: [
              /* @__PURE__ */ jsx4(ChevronLeft, { className: "size-5" }),
              language === "no" ? "Tilbake" : "Back"
            ]
          }
        ),
        /* @__PURE__ */ jsxs3("div", { className: "mx-5 md:mx-10 text-ink-primary", children: [
          /* @__PURE__ */ jsxs3(
            RadioGroup,
            {
              slotProps: {
                group: {
                  className: "mb-6 legend:text-r["
                }
              },
              groupTitle: language === "no" ? "M\xF8rk modus" : "Dark mode",
              radioName: "theme",
              children: [
                /* @__PURE__ */ jsx4(
                  Radio,
                  {
                    checked: currentTheme === "light",
                    value: "light",
                    onChange: (e) => toggleTheme(e.target.value),
                    children: language === "no" ? "Av" : "Off"
                  }
                ),
                /* @__PURE__ */ jsx4(
                  Radio,
                  {
                    checked: currentTheme === "dark",
                    value: "dark",
                    onChange: (e) => toggleTheme(e.target.value),
                    children: language === "no" ? "P\xE5" : "On"
                  }
                ),
                /* @__PURE__ */ jsx4(
                  Radio,
                  {
                    checked: currentTheme === "auto",
                    value: "auto",
                    onChange: (e) => toggleTheme(e.target.value),
                    children: language === "no" ? "Automatisk" : "Automatic"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs3("div", { className: "mt-5 px-5 py-4 flex gap-4 bg-fill-quaternary rounded-2xl typography-body-small", children: [
            /* @__PURE__ */ jsx4(InfoCircle, { className: "w-6 h-[30px]" }),
            language === "no" ? "Valget ditt blir lagret i en informasjonskapsel og gjelder kun for denne nettleseren." : "Your choice will be saved in cookies and will only be valid for this browser"
          ] })
        ] })
      ]
    }
  );
};

// src/header/menu.tsx
import { Button } from "@ds/button";

// src/header/menu-store.ts
import { create } from "zustand";
var useMenuStore = create()((set) => ({
  activeMenu: "closed",
  setActiveMenu: (menu) => set({ activeMenu: menu })
}));

// src/header/menu.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var Menu = ({
  language,
  primaryMenu,
  languageUrl,
  onClickTracking,
  onToggleClickTracking,
  domain,
  isLoggedIn,
  searchUrl
}) => {
  const { activeMenu, setActiveMenu } = useMenuStore();
  const menuOpen = activeMenu !== "closed";
  function handleMenuChange(menu) {
    setActiveMenu(menu);
  }
  return /* @__PURE__ */ jsxs4("div", { children: [
    /* @__PURE__ */ jsx5(
      Button,
      {
        skin: "SECONDARY",
        className: "relative z-[22] w-[107px] h-10",
        endIcon: menuOpen ? /* @__PURE__ */ jsx5(Cross, { className: "size-6" }) : /* @__PURE__ */ jsx5(Hamburger, { className: "size-6" }),
        onClick: () => setActiveMenu(menuOpen ? "closed" : "navigation"),
        children: /* @__PURE__ */ jsx5("span", { className: "text-body-medium font-[400]", children: menuOpen ? language === "no" ? "Lukk" : "Close" : language === "no" ? "Meny" : "Menu" })
      }
    ),
    /* @__PURE__ */ jsx5(
      NavigationMenu,
      {
        domain,
        isLoggedIn,
        language,
        primaryMenu,
        languageUrl,
        onClickTracking,
        searchUrl,
        show: activeMenu === "navigation",
        setActiveMenu: handleMenuChange
      }
    ),
    /* @__PURE__ */ jsx5(
      ChangeTheme,
      {
        language,
        onToggleClickTracking,
        show: activeMenu === "theme",
        closeTheme: () => setActiveMenu("navigation")
      }
    ),
    /* @__PURE__ */ jsx5(
      "div",
      {
        onClick: () => setActiveMenu("closed"),
        className: cn3(
          "fixed inset-0 z-20 h-full w-full transition-[opacity_visiblity] duration-0 bg-other-overlay motion-reduce:duration-0",
          !menuOpen && "invisible opacity-0",
          menuOpen && "duration-200"
        )
      }
    )
  ] });
};

// src/header/useScroll.ts
import { useEffect as useEffect3, useRef, useState as useState3 } from "react";
function useScroll() {
  const [showHeader, setShowHeader] = useState3(true);
  const lastScrollY = useRef(0);
  useEffect3(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY.current && currentScrollY > 50) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }
      lastScrollY.current = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return showHeader;
}

// src/header/index.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var Header = ({
  language,
  headerLinks,
  primaryMenu,
  languageUrl,
  onClickTracking,
  onToggleClickTracking,
  searchUrl,
  domain = "https://ruter.no",
  logoUrl = "/",
  env = "prod"
}) => {
  const activeMenu = useMenuStore((state) => state.activeMenu);
  const menuOpen = activeMenu !== "closed";
  const showHeader = useScroll();
  const [isLoggedIn, setIsLoggedIn] = useState4(false);
  useEffect4(() => {
    setIsLoggedIn(checkLoggedIn(env));
  }, [env]);
  const filteredHeaderLinks = headerLinks?.filter((link) => {
    const title = getSanityLocalizedField2(
      link.title,
      language
    )?.toLowerCase();
    return title !== "logg inn" && title !== "log in";
  }) || [];
  return /* @__PURE__ */ jsxs5(
    "header",
    {
      className: `sticky top-0 z-[20] md:h-[80px] md:px-10 flex-shrink-0 typography-body-medium text-ink-primary flex h-[72px] w-full items-center justify-between px-5 bg-background-secondary transition-transform duration-300 overflow-hidden ${!showHeader && !menuOpen && "-translate-y-full"}`,
      children: [
        /* @__PURE__ */ jsxs5("a", { href: logoUrl, className: "relative z-50 flex", children: [
          /* @__PURE__ */ jsx6(LogotypeRuterSecondary, { className: "w-[85px] md:w-[112px] dark:block hidden" }),
          /* @__PURE__ */ jsx6(LogotypeRuterPrimary, { className: "w-[85px] md:w-[112px] dark:hidden block" })
        ] }),
        /* @__PURE__ */ jsxs5("div", { className: "hidden gap-3 md:flex", children: [
          filteredHeaderLinks?.map((link, i) => /* @__PURE__ */ jsxs5(
            "a",
            {
              className: "flex items-center gap-1.5 px-5 py-2.5 hover:cursor-pointer",
              href: link.url,
              onClick: () => {
                if (onClickTracking) {
                  onClickTracking(link.url);
                }
              },
              children: [
                link.icon && /* @__PURE__ */ jsx6(IllustrationBlock, { svg: link.icon }),
                getSanityLocalizedField2(link.title, language)
              ]
            },
            `header_${i}`
          )),
          /* @__PURE__ */ jsxs5(
            "a",
            {
              className: "flex items-center gap-1.5 px-5 py-2.5 hover:cursor-pointer w-[140px]",
              href: "https://minside.ruter.no",
              children: [
                /* @__PURE__ */ jsx6(ProfileOutlineThicker, { className: "size-5" }),
                isLoggedIn ? language === "no" ? "Profil" : "Profile" : language === "no" ? "Logg inn" : "Log in"
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsx6(
          Menu,
          {
            domain,
            isLoggedIn,
            language,
            searchUrl,
            onClickTracking,
            onToggleClickTracking,
            primaryMenu,
            languageUrl
          }
        )
      ]
    }
  );
};
export {
  Header
};
